import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { IS_ON_OFF } from 'src/constants/Options';
import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { getOptionLabel, display, currency, numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import { getRadioOptions } from 'src/reducers/selectOptions';

import tableStyles from '../styles/GeneralTableInfo.scss';

const TaxCalculationSectionShow = props => {
  const { employeeTaxCalculationSettings, taxOnTaxStatuses, taxCalculationYear, residentClassificationOptions, nonResidentTaxOptions } = props;
  const { t } = useTranslation();

  const employeeTaxSetting = employeeTaxCalculationSettings[taxCalculationYear];
  const isTaxCalculation = employeeTaxSetting?.isTaxCalculation;
  const isResident = employeeTaxSetting?.residentClassification === 'resident';

  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>{t('features.Employees.components.TaxCalculationSectionShow.enable_tax_calculation')}:</th>
            <td>{display(getOptionLabel(isTaxCalculation ? '1' : '0')(IS_ON_OFF))}</td>
          </tr>
          {isTaxCalculation && (
            <>
              {/* Tax on Tax Setting */}
              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.tax_on_tax_setting')}</th>
                <td>{display(getOptionLabel(employeeTaxSetting.taxOnTaxSetting)(taxOnTaxStatuses))}</td>
              </tr>

              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.resident_classification')}</th>
                <td>{display(getOptionLabel(employeeTaxSetting.residentClassification)(residentClassificationOptions))}</td>
              </tr>

              {!isResident && (
                <tr>
                  <th>{t('features.Employees.components.TaxCalculationSectionShow.non_resident_tax_setting')}</th>
                  <td>{display(getOptionLabel(employeeTaxSetting.nonResidentTaxSetting)(nonResidentTaxOptions))}</td>
                </tr>
              )}

              {/* Dependant number */}
              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.dependant_number')}:</th>
                <td>{employeeTaxSetting.dependantNumber}</td>
              </tr>

              {/* @TODO: Hide Provident Fund for Vietnam */}
              {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
              {/*
              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.provident_fund_allowance')}:</th>
                <td>{display(getOptionLabel(employeeTaxSetting.isProvidentFundAllowance ? '1' : '0')(IS_ON_OFF))}</td>
              </tr>
              */}

              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.charity_amount')}:</th>
                <td>{currency(numberWithComma(decimalPlace2(employeeTaxSetting.charityAmount)))}</td>
              </tr>

              {/* General donation */}
              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.general_donation_amount')}:</th>
                <td>{currency(numberWithComma(decimalPlace2(employeeTaxSetting.generalDonationAmount)))}</td>
              </tr>

              {/* Abroad income tax amount */}
              <tr>
                <th>{t('features.Employees.components.TaxCalculationSectionShow.abroad_income_tax_amount')}:</th>
                <td>{currency(numberWithComma(decimalPlace2(employeeTaxSetting.abroadIncomeTaxAmount)))}</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeTaxCalculationSettings: selector(getItem(REDUCER_NAME, state), 'employeeTaxCalculationSettings'),
  taxOnTaxStatuses: getRadioOptions(state, 'taxOnTaxStatuses'),
  residentClassificationOptions: getRadioOptions(state, 'residentClassificationOptions'),
  nonResidentTaxOptions: getRadioOptions(state, 'nonResidentTaxOptions')
});

export default connect(mapStateToProps)(TaxCalculationSectionShow);
